"use strict";

exports.__esModule = true;

var reducer_1 = require("./reducer");

var state_1 = require("./state");

function dispatch(action) {
  state_1.update(reducer_1["default"](state_1.state, action));
}

exports["default"] = dispatch;